<ng-template #displayTemplateRef
             let-cellData>
  <span scOverflowTooltip>
    {{ getCellValue(cellData) | date:format }}
  </span>
</ng-template>